/**
 * The id rule of a creature or NPC template, a look and a sound: lower-case letters, digits and hyphens. One rule, so
 * content that names a template accepts every id a template may have.
 */
export const SLUG_PATTERN = /^[a-z0-9-]+$/;
